import { render, staticRenderFns } from "./Resume.vue?vue&type=template&id=36ddeb73&scoped=true&"
import script from "../js/Resume.js?vue&type=script&lang=js&"
export * from "../js/Resume.js?vue&type=script&lang=js&"
import style0 from "../styles/resume.sass?vue&type=style&index=0&id=36ddeb73&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ddeb73",
  null
  
)

export default component.exports